import React, { useContext, useEffect, useState } from "react";
import "./panvel.css";
import { useLayerFunc } from "../Main/layerFunc";
import { GlobalContext } from "../../App";

function KalmboliWardProj() {
  const { LayerChange, TileLayerChange, handleOpen } = useLayerFunc();
  const { SetLogout } = useContext(GlobalContext);

  useEffect(() => {
    SetLogout(true);
  }, []);

  return (
    <>
      <details
        className="baseline"
       onToggle={() => handleOpen("Kalamboli_ward_Kalamboli_Boundary")}
      >
        <summary>Kalamboli-Ward</summary>
        <div className="baseline-cont">
          <div className="opt-div">
            <input
                  value="Kalamboli_ward_Kalamboli_Boundary"
                  id="Kalamboli_ward_Kalamboli_Boundary"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                  
                />
            <label>Boundary</label>
          </div>
          <details id="townD">
            <summary className="townS">Baseline</summary>
            <div className="town-cont">
              <div className="opt-div">
                <input
                  value="Kalamboli_ward_Baseline_Road_Network"
                  id="Kalamboli_ward_Baseline_Road_Network"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Road</label>
              </div>
        
              <div className="opt-div">
                <input
                  value="Kalamboli_ward_Baseline_Railway_Network"
                  id="Kalamboli_ward_Baseline_Railway_Network"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Railways</label>
              </div>
              
              <div className="opt-div">
                  <input
                    value="Kalamboli_ward_Baseline_Tree"
                    id="Kalamboli_ward_Baseline_Tree"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Tree</label>
                </div>
              <div className="opt-div">
                  <input
                    value="Kalamboli_ward_Baseline_Water_Body"
                    id="Kalamboli_ward_Baseline_Water_Body"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(
                        e.target.value,
                        e.target.id,
                        e.target.checked,
                        false,
                        true
                      )
                    }
                  />
                  <label>Waterbody</label>
                </div>
                  
                 <div className="opt-div">
                  <input
                    value="Kalamboli_ward_Baseline_mangrove_Swamps"
                    id="Kalamboli_ward_Baseline_mangrove_Swamps"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Mangrove Swamps</label>
                </div>
                <div className="opt-div">
                <input
                  value="Kalamboli_ward_Baseline_Total_Builtup"
                  id="Kalamboli_ward_Baseline_Total_Builtup"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Total Builtup</label>
              </div>
            </div>
            </details>
            
               <details id="townD">
              <summary className="townS">Town Planning</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
                <div className="opt-div">
                  <input
                    value="Kalamboli_ward_Town_Planning_Prabhag"
                    id="Kalamboli_ward_Town_Planning_Prabhag"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Prabhag</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kalamboli_ward_Town_Planning_Kalamboli_jurisdiction"
                    id="Kalamboli_ward_Town_Planning_Kalamboli_jurisdiction"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Jurisdiction</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kalamboli_ward_Town_Planning_Nodal_Sector"
                    id="Kalamboli_ward_Town_Planning_Nodal_Sector"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Sectors</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kalamboli_ward_Town_Planning_Nodal_Plot"
                    id="Kalamboli_ward_Town_Planning_Nodal_Plot"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Plots</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kalamboli_ward_Town_Planning_Village_Boundary"
                    id="Kalamboli_ward_Town_Planning_Village_Boundary"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village Boundary </label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kalamboli_ward_Town_Planning_Village_Survey"
                    id="Kalamboli_ward_Town_Planning_Village_Survey"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village survey</label>
                </div>
               
              </div>
            </details>
            
            <details id="townD">
              <summary className="townS">Builtup Change</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
                <div className="opt-div">
                  <input
                    value="Kalamboli_authorised"
                    id="Kalamboli_authorised"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Authorised</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kalamboli_Unauthorised"
                    id="Kalamboli_Unauthorised"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Unauthorised</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kalamboli_Other_Authority"
                    id="Kalamboli_Other_Authority"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Other Authority</label>
                </div>
                 <div className="opt-div">
                  <input
                    value="Kalamboli_Pending"
                    id="Kalamboli_Pending"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label> Pending </label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kalamboli_shed"
                    id="Kalamboli_shed"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label> Shed </label>
                </div>
                <div style={{ display: "none" }} className="opt-div">
                  <input
                    value="Kalamboli_total_builtup_jan2023"
                    id="Kalamboli_total_builtup_jan2023"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Total builtup jan2023</label>
                </div>
              </div>
            </details>

           <details id="townD">
            <summary className="townS">Images</summary>
            <div className="town-cont mb-3">
              <div className="opt-div">
                <input
                  value="Jan_2023"
                  id="Kalamboli_ward_Kalamboli_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "Jan 2023",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>Jan 2023</label>
              </div>
              <div className="opt-div">
                <input
                  value="March_2025"
                  id="Kalamboli_ward_Kalamboli_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "March 2025",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>March 2025</label>
              </div>
            </div>
          </details>
        </div>
      </details>
    </>
  );
}

export default KalmboliWardProj;
